// config/tokenUsageEndpoints.js
// Token Usage API Endpoints Configuration
import { API_BASE_URL } from '../../../shared/config/apiConfig';

const TOKEN_METRICS_BASE = `${API_BASE_URL}/metrics`;

/**
 * Token Usage & Metrics Endpoints
 */
export const TOKEN_USAGE_ENDPOINTS = {
  // Base URL
  BASE: TOKEN_METRICS_BASE,

  // Overview metrics
  overview: `${TOKEN_METRICS_BASE}/overview`,

  // Trends data
  trends: `${TOKEN_METRICS_BASE}/trends`,

  // User metrics
  users: `${TOKEN_METRICS_BASE}/users`,

  // User details
  userDetails: (userId) => `${TOKEN_METRICS_BASE}/user-details?userId=${userId}`,

  // User conversations
  userConversations: (userId) => `${TOKEN_METRICS_BASE}/user-conversations?userId=${userId}`,

  // Export data
  export: `${TOKEN_METRICS_BASE}/export`
};

export default TOKEN_USAGE_ENDPOINTS;
